import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../utils/firebase';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Get the page name from the path, removing leading slash and using 'home' for root
    const pageName = location.pathname === '/' ? 'home' : location.pathname.slice(1);
    
    // Log the page view with more structured data
    logPageView({
      page_title: pageName.charAt(0).toUpperCase() + pageName.slice(1), // Capitalize first letter
      page_path: location.pathname,
      page_location: window.location.href,
      screen_name: pageName // This is important for Firebase Analytics categorization
    });
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker; 